import React, { Component } from 'react';
import { Redirect } from 'react-router'

import Filterable from '../components/ui/filter/Filterable.js';
import FarmForm from '../components/farm/form.js';
import FarmSummary from '../components/farm/summary.js';
import Box from '../components/ui/Box.js';
//import HarvestChart from '../components/charts/HarvestChart.js';
import CostsChartGroup from '../components/charts/CostsChartGroup.js';

import api from '../api/index.js';

import './Dashboard.scss'

class Page extends Component {
	constructor(props) {
		super(props);
		this.state = {
			children: false,
			redirect: false,
		};
	}

	
	async refresh() {
		console.log("Loading data for range", [this.props.dateStart, this.props.dateEnd].map((a) => { return a.api();}));
		try {
			let data = await api.get('farms?from=' + this.props.dateStart.api() + '&until=' + this.props.dateEnd.api());
			let total_acreage = 0;
			for(let i in data) {
				for(let j=0; j < data[i].crops.length; j++) {
					const a = parseFloat(data[i].crops[j].Acres);
					if (!isNaN(a))
						total_acreage += a;
				}
			}
			for(let i in data) {
				data[i].totalAcreage = total_acreage;
			}
			data = data.map((a) => {
				a['discontinued'] = api.isCurrentlyDisabled(a.DiscontinuedDate);
				return a;
			});
			data = data.sort((a, b) => {
				if (a.discontinued && !b.discontinued)
					return 1;
				if (!a.discontinued && b.discontinued)
					return -1;
				if (a.FarmName > b.FarmName)
					return 1;
				if (a.FarmName < b.FarmName)
					return -1;
				return 0;
			});
			this.setState({children: data});
			
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	
	componentDidMount() {
		this.refresh();
	}
	
	selectChild = (data) => {
		this.setState({redirect: '/farm/' + data.FarmID});
	}
	
	onAddSubmit = async (e) => {
		//close interface, redirect to farm page
		this.setState({redirect: '/farm/' + e});
		return true;
	}
	
	filter = (data, filterstring) => {
		let filtered = [];
		const f = filterstring.toLowerCase();
		for(let i in data) {
			const d = data[i];
			if (d.FarmName.toLowerCase().includes(f) || d.Address.toLowerCase().includes(f) || d.City.toLowerCase().includes(f)) {// Do this better later, and add in crops etc.
				filtered.push(d);
			} else {
				for(let j=0; j < d.crops.length; j++) {
					if (d.crops[j].CropName && d.crops[j].CropName.toLowerCase().includes(f)) {
						filtered.push(d);
						break;
					}
				}
			}
		}
		return filtered;
	}
	
	componentDidUpdate(priorProps) {
		if (priorProps.dateStart !== this.props.dateStart || priorProps.dateEnd !== this.props.dateEnd) {
			this.refresh();
		}
	}

	//	<HarvestChart dateStart={this.props.dateStart} dateEnd={this.props.dateEnd} />
	
	render() {
		if (this.state.redirect)
			return  <Redirect to={this.state.redirect} />
	
		return <div className="Company Specific">
				<Box title="Company name" modalTitle="Company actions" options={[
					{
						label: "Option one",
						callback: ()=>{console.log("Option 1 clicked");}
					},
					{
						label: "Option two",
						callback: ()=>{console.log("Option 2 clicked")}
					},
					{
						label: "Option three",
						callback: ()=>{console.log("Option 3 clicked")}
					},
					{
						label: "NOOP"
					}
				]}>
					<div className="widget-holder">
						<CostsChartGroup dateStart={this.props.dateStart} dateEnd={this.props.dateEnd} />
					</div>
				</Box>
				<Filterable 
					summaryComponent={FarmSummary}
					addForm={FarmForm}
					onAddSubmit={this.onAddSubmit}
					filter={this.filter}
					children={this.state.children}
					onSelect={this.selectChild}
					type="farm"
					
				/>
			</div>;
	}
}

export default Page;